module.exports = __webpack_public_path__ + "c6e4a147afab7d1f38269702be5bef91.otf";


//////////////////
// WEBPACK FOOTER
// ./client/assets/fonts/Platform-Light.otf
// module id = 1099
// module chunks = 0